var _excluded = ["input", "meta", "onChangeCallback"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
import { Field } from "redux-form";
import Select from "../react-select/Select";
function SelectField(_ref) {
  var input = _ref.input,
    _ref$meta = _ref.meta,
    touched = _ref$meta.touched,
    error = _ref$meta.error,
    onChangeCallback = _ref.onChangeCallback,
    custom = _objectWithoutProperties(_ref, _excluded);
  function handleChange(value) {
    onChangeCallback && onChangeCallback(value);
    input.onChange(value);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Select, _extends({}, input, custom, {
    onChange: handleChange,
    onBlur: function onBlur() {
      return input.onBlur();
    }
  })), touched && error && /*#__PURE__*/React.createElement("span", {
    className: "small text-danger"
  }, error));
}
export default (function (props) {
  return /*#__PURE__*/React.createElement(Field, _extends({}, props, {
    component: SelectField
  }));
});